export default __webpack_public_path__ + "jpn.48461fa.png";